import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useVForm } from '../../../shared/forms';
interface IFormData {
  iditens: string;
  qtde: number;
  qtds: number;
  un: string;
  preco: number;
  total: number;
  filtro: string;
  descricao: string;
}
export interface IMovimentoData {
  iditens: string;
  descricao: string;
  idmov: string;
  idprod: string;
  preco: number;
  total: number;
  qtds: number;
  un: string;
  tipo: number;
}
export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  status: boolean;
  dados?: IFormData;
  movimentoData?: IMovimentoData[];
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
}
export const DialogFaturameto: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { formRef, save } = useVForm();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { onClose, value: valueProp, open, movimentoData, ...other } = props;
  const [isLoading] = useState(false);
  const [id, setId] = useState('');
  const [items, setItems] = useState<IMovimentoData[]>([]);

  useEffect(() => {
    if (props.dados && typeof props.dados === 'object') {
      formRef.current?.setData(props.dados);
    }
  }, [id, formRef, props.dados]);
  useEffect(() => {
    if (props.movimentoData && props.movimentoData.length > 0) {
      setItems(props.movimentoData);
    } else {
      setItems([]);
    }
  }, [props.movimentoData]);
  const handleCancel = () => {
    onClose();
  };
  useEffect(() => {
    if (!open) {
      //fazio
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };
  const calcularTotalGeral = () => {
    return items.reduce((total, item) => total + (item.total || 0), 0);
  };
  return (
    <Dialog
      open={open}
      {...other}
      sx={{ width: '100%' }}
      maxWidth="lg"
    >
      <DialogContent dividers>
        <Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Itens ({items.length})
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: 'grey.100' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Descrição</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">Quantidade</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">UN</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Preço Unitário</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.length > 0 ? (
                  items.map((item, index) => (
                    <TableRow key={item.iditens || index}>
                      <TableCell>{item.descricao}</TableCell>
                      <TableCell align="center">{item.qtds}</TableCell>
                      <TableCell align="center">{item.un}</TableCell>
                      <TableCell align="right">{formatCurrency(item.preco)}</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {formatCurrency(item.total)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                      <Typography variant="body2" color="textSecondary">
                        Nenhum item encontrado
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              {items.length > 0 && (
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'grey.200' }}>
                    <TableCell colSpan={4} align="right" sx={{ fontWeight: 'bold' }}>
                      Total Geral:
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                      {formatCurrency(calcularTotalGeral())}
                    </TableCell>
                  </TableRow>
                </TableHead>
              )}
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' disabled={props.status === false ? isLoading : true} autoFocus onClick={save}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};